import Beat from '../models/beat';

export default class Playlist {
    constructor(playlist = [], name = "", id = null) {
        this.playlist = this.copyPlaylist(playlist)
        this.name = name;
        this.playing = null;
        this.firstPlay = true;
        this.id = id
    }

    setPlaylistItems (musicArray) {
        this.playlist = musicArray
    }

    addPlaylistItems (musicArray) {
        musicArray = this.copyPlaylist(musicArray)

        for (var i = 0; i < musicArray.length; i++) {
            this.addPlaylistItem(musicArray[i])
        }
    }

    addPlaylistItem (music) {
        this.playlist.push(music)
    }

    removePlaylistItem (music) {
        for (let i = 0; i < this.playlist.length; i++) {
            if (this.playlist[i].itemId == music.itemId) {
                this.playlist.splice(i, 1)
                break
            }
        }
    }

    removePlaylistItems (music) {
        for (let i = 0; i < music.length; i++) {
            for (let j = 0; j < this.playlist.length; j++) {
                if (this.playlist[j].itemId == music[i].itemId) {
                    this.playlist.splice(j, 1)
                }
            }
        }
    }

    emptyPlaylist () {
        this.playlist = []
    }

    getPlaylist () {
        return this.playlist
    }

    getCurrentlyPlaying () {
        return this.playing
    }

    getName () {
        return this.name
    }

    setName (name) {
        this.name = name
    }

    setCurrentlyPlaying (music) {
        this.playing = music
    }

    isFirstPlay () {
        return this.firstPlay
    }

    setFirstPlay (boolean) {
        this.firstPlay = boolean
    }

    isPlaying(music) {
        if (this.playing)
            return (music.id == this.playing.id && music.getType() == this.playing.getType())

        return false
    }

    addNext (music) {
        if (!this.playing) {
            this.playlist.splice(0, 0, music)
        } else {
            for (var i = 0; i < this.playlist.length; i++) {
                if (this.playlist[i].itemId == this.playing.itemId) {
                    this.playlist.splice(i + 1, 0, music)
                    break
                }
            }
        }
    }

    getNextInPlaylist () {
        if (this.playing) {
            for (var i = 0; i < this.playlist.length; i++) {
                if (this.playing.itemId == this.playlist[i].itemId) {
                    for (var o = i + 1; o < this.playlist.length; o++) {
                        if (this.playlist[o] != undefined) {
                            return this.playlist[o]
                        }
                    }
                    break
                }
            }
        }

        return this.playlist[0];
    }

    getPrevInPlaylist () {
        if (this.playing) {
            for (var i = 0; i < this.playlist.length; i++) {
                if (this.playing.itemId == this.playlist[i].itemId) {

                    if (this.playlist[i - 1] != undefined) {
                        return this.playlist[i - 1];
                    } else {
                        return this.playlist[0];
                    }
                }
            }
        }

        return this.playlist[0];
    }

    getLastPlayed () {
        if (this.playing) {
            for (var i = 0; i < this.playlist.length; i++) {
                if (this.playing.itemId == this.playlist[i].itemId) {
                    return this.playlist[i];
                }
            }
        }

        return this.playlist[0];
    }

    copyPlaylist(playlist) {
        let copy = jQuery.extend(true, [], playlist);
        return copy;
    }

    static parseUserPlaylist(playlist) {
        let list = []

        for (var i = 0; i < playlist.length; i++) {
            let item = playlist[i].music_item

            if (item && item.id != undefined) {
                item.playlist_order = playlist[i].playlist_order
                item.playlist_item_id = playlist[i].id
                list.push(new Beat(item))
            }
        }

        return list
    }

}